import { render, staticRenderFns } from "./Dots.vue?vue&type=template&id=69a902ce"
import script from "./Dots.vue?vue&type=script&lang=ts"
export * from "./Dots.vue?vue&type=script&lang=ts"
import style0 from "./Dots.vue?vue&type=style&index=0&id=69a902ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports